<template>
	<div class="info-card-wrapper">
		<div class="title">
			<slot name="title">
				<rd-text class="font-h4-medium" textType="title" :bigger="true">{{ title }}</rd-text>
			</slot>
		</div>

		<div class="content font-h4-regular">
			<slot class="content" name="content"></slot>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
	},
};
</script>
<style lang="less" scoped>
.info-card-wrapper {
	border: 1px solid @color-gy3;
	border-radius: 8px;
	.title,
	.content {
		padding: 12px;
	}

	.title {
		background-color: #f9f8fd;
	}
	.font-h4-medium {
		line-height: 24px;
	}
}
</style>